export const NOTIFY = {
    name: "notify",
    uuid: 0x6E01,
    properties: ["read", "write", "notify"],
  };
  